import React from 'react';
import { motion } from 'framer-motion';
const collections = [{
  id: 1,
  title: 'Палаццо шерсть',
  description: 'Колір капучино — теплий і м’який базовий образ на холодний сезон.',
  image: 'https://cdn.magicpatterns.com/uploads/82rP4KSqvYB1Ma1TG9AhbM/Зображення_14.jpg'
}, {
  id: 2,
  title: 'Спідниця з екошкіри',
  description: "Той самий силует з об'ємним бомбером на кожен день.",
  image: 'https://cdn.magicpatterns.com/uploads/2Jm6eLXJa15rjEVTaDu6KJ/Зображення_62.jpg'
}, {
  id: 3,
  title: 'Палаццо з екошкіри',
  description: 'Чорні широкі штани з шовковою майкою — для вечора.',
  image: 'https://cdn.magicpatterns.com/uploads/r5Q8uQbhv2L1fQQFcAE2ix/Зображення_59.jpg'
}, {
  id: 4,
  title: 'Палаццо з екошкіри',
  description: 'Шоколадний відтінок — теплий акцент осіннього гардеробу.',
  image: 'https://cdn.magicpatterns.com/uploads/qWmJKanNzyJKeivezMnQXj/photo_5382105999629558326_y.jpg'
}];
export function Collections() {
  return <section id="collections" className="py-24 bg-brand-cream" data-id="element-85" data-mp="1bphq2pbh9p70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86" data-mp="16wolc1g0egux">
        <div className="text-center mb-16" data-id="element-87" data-mp="16vdj4627ph5x">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-88" data-mp="11xbwxc9hp1q8">
            Вибрані колекції
          </h2>
          <p className="text-brand-dark/70 max-w-2xl mx-auto" data-id="element-89" data-mp="x0lkr00t2qa3">
            Ретельно підібрані речі, створені, щоб доповнити ваш гардероб
            позачасовою вишуканістю.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-90" data-mp="1po90o1r4ssqe">
          {collections.map((collection, index) => <motion.div key={collection.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col" data-id="element-91" data-mp="1kqfyrkwv2kvx" data-mpi={index}>
              <div className="aspect-[3/4] overflow-hidden rounded-2xl mb-4" data-id="element-92" data-mp="2ihcmrgyix59d">
                <img src={collection.image} alt={`${collection.title}. ${collection.description}`} className="w-full h-full object-cover photo-grade" data-id="element-93" data-mp="2ngfn4o3k6nb0" />
              </div>
              <h3 className="text-xl md:text-2xl font-serif text-brand-dark mb-1" data-id="element-94" data-mp="2dl5nu84jou0x">
                {collection.title}
              </h3>
              <p className="text-sm text-brand-dark/70 leading-relaxed" data-id="element-95" data-mp="24qhg8bbhz08y">
                {collection.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}